export default __webpack_public_path__ + "static/media/dot_img_careadmin.1f4c1849.svg";